import React from 'react';
import Scrollspy from 'react-scrollspy';
import { Link } from 'gatsby';

import { active } from './styles.module.scss';

const AsideNav = ({ data }) => {
  const slugs = data.map(({ link }) => link);

  return data.length > 0 ?
    <Scrollspy
      className={'pt-8 pl-8 border-t border-mine-shaft lg:sticky lg:top-40'}
      currentClassName={active}
      items={slugs}
      offset={100}
    >
      {data.map((item, index) => (
        <li key={index} className={'oc-lead-2 mb-3.5'}>
          <Link to={`#${item.link}`}>{item.lable}</Link>
        </li>
      ))}
    </Scrollspy> :
    null;
};

export default AsideNav;
